import Layout from '@/page/index/'

import urlSettings from '@/config/url-settings.js';


export default [{
  path: '/wel',
  component: Layout,
  redirect: '/wel/index',
  children: [{
    path: 'index',
    name: '首页',
    meta: {
      i18n: 'dashboard'
    },
    component: () =>
    urlSettings.VUE_APP_ENV_NAME=='cjyl'?import( /* webpackChunkName: "views" */ '@/views/wel/wy-index/nursingHomeIndex'):urlSettings.VUE_APP_ENV_NAME=='cjjgj'?import( /* webpackChunkName: "views" */ '@/views/wel/wy-index/index-cjjgj'):import( /* webpackChunkName: "views" */ '@/views/wel/wy-index/index')
  }, {
    path: 'dashboard',
    name: '控制台',
    meta: {
      i18n: 'dashboard',
      menu: false,
    },
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/wel/dashboard')
  }]
}, {
  path: '/test',
  component: Layout,
  redirect: '/test/index',
  children: [{
    path: 'index',
    name: '测试页',
    meta: {
      i18n: 'test'
    },
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/util/test')
  }]
}, {
  path: '/dict-horizontal',
  component: Layout,
  redirect: '/dict-horizontal/index',
  children: [{
    path: 'index',
    name: '字典管理',
    meta: {
      i18n: 'dict'
    },
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/util/demo/dict-horizontal')
  }]
}, {
  path: '/dict-vertical',
  component: Layout,
  redirect: '/dict-vertical/index',
  children: [{
    path: 'index',
    name: '字典管理',
    meta: {
      i18n: 'dict'
    },
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/util/demo/dict-vertical')
  }]
}, {
  path: '/info',
  component: Layout,
  redirect: '/info/index',
  children: [{
    path: 'index',
    name: '个人信息',
    meta: {
      i18n: 'info'
    },
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/system/userinfo')
  }]
}, {
  path: '/work/process/leave',
  component: Layout,
  redirect: '/work/process/leave/form',
  children: [{
    path: 'form/:processDefinitionId',
    name: '请假流程',
    meta: {
      i18n: 'work'
    },
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/work/process/leave/form')
  }, {
    path: 'handle/:taskId/:processInstanceId/:businessId',
    name: '处理请假流程',
    meta: {
      i18n: 'work'
    },
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/work/process/leave/handle')
  }, {
    path: 'detail/:processInstanceId/:businessId',
    name: '请假流程详情',
    meta: {
      i18n: 'work'
    },
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/work/process/leave/detail')
  }]
},
{
  path: '/form-generator',
  component: Layout,
  redirect: '/form-generator/form-generator',
  children: [
    {
      path: 'form-generator',
      name: '表单设计器',
      meta: {
        i18n: 'form-generator',
      },
      component: () =>
        import(/* webpackChunkName: "views" */ '@/views/form-design/form-generator'),
    },
  ],
},
{
  path: '/form-data',
  component: Layout,
  redirect: '/form-data/form-data',
  children: [
    {
      path: 'form-data',
      name: '表单数据',
      meta: {
        i18n: 'form-data',
      },
      component: () => import(/* webpackChunkName: "views" */ '@/views/form-design/form-data'),
    },
  ],
},
{
  path: '/form-detail',
  component: Layout,
  redirect: '/form-detail/form-detail',
  children: [
    {
      path: 'form-detail',
      name: '表单页面',
      meta: {
        i18n: 'form-detail',
      },
      component: () => import(/* webpackChunkName: "views" */ '@/views/form-design/form-detail'),
    },
  ],
},
{
  path: '/contract-add',
  component: Layout,
  children: [
    {
      path: '/contract-add',
      name: '合同录入',
      component: () => import(/* webpackChunkName: "views" */ '@/views/crmedical/contract/add/index'),
    },
  ],
},
{
  path: '/contract-execute',
  component: Layout,
  children: [
    {
      path: '/contract-execute',
      name: '合同执行',
      component: () => import(/* webpackChunkName: "views" */ '@/views/crmedical/contract/execution/index'),
    },
  ],
},

]
